module.exports = __webpack_public_path__ + "img/UTECHO-1.64bae370.jpg";